import ChatMessageViewState, { ChatMessageType } from '../store/schema/ChatMessageViewState';
import * as trace from 'owa-trace';
import * as React from 'react';

import styles from './ChatMessage.scss';
import classNames from 'classnames';

export interface ChatMessageProps {
    chatMessage: ChatMessageViewState;
    isSelf: boolean;
}

export default function ChatMessage(props: ChatMessageProps) {
    const { chatMessage } = props;

    let message = undefined;

    switch (chatMessage.messageType) {
        case ChatMessageType.InstantMessage:
        case ChatMessageType.InstantMessageFromToast:
            message = chatMessage.message;
            break;
        case ChatMessageType.ParticipantJoin:
        case ChatMessageType.ParticipantLeave:
        case ChatMessageType.FailedDelivery:
        case ChatMessageType.DeliveryTimeout:
            trace.errorThatWillCauseAlert('unexpected message type for chat message');
            break;
    }

    return message ? (
        <div
            className={classNames(
                styles.messageContainer,
                props.isSelf ? styles.self : styles.other
            )}>
            <span>{message}</span>
        </div>
    ) : null;
}
